// Import routes
import { AuthPaths } from 'components/routes/auth/routes';

export const redirectPaths = [
	{ from: '/rejestracja', to: AuthPaths.Registration },
	{ from: '/reset-hasla/:hash?', to: AuthPaths.PasswordReset },
	{ from: '/potwierdzenie-email/:hash', to: AuthPaths.EmailConfirmation },
	{ from: '/logowanie', to: AuthPaths.Login }
];
